import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { HolidaysCalendarDto } from './holidays-calendar.dto';


export class AllHolidaysCalendarResponseModel extends GlobalResponseObject{
    data?: HolidaysCalendarDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: HolidaysCalendarDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}